import { render, staticRenderFns } from "./EditLanguageSelection.vue?vue&type=template&id=50d9da25"
import script from "./EditLanguageSelection.vue?vue&type=script&lang=ts"
export * from "./EditLanguageSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports